import React, { MutableRefObject, useEffect, useRef, useState } from 'react'
import {
    getReportActionsState,
    getVuObjInfoState,
    getVUParamsInfoState,
    setVuObjectInfoStore,
} from '../../Redux/VisualUnits/visualUnitStateSlice'
import { useDispatch, useSelector } from 'react-redux'
import {
    useGetVUParamsMutation,
    useGetFiltersMutation,
    useGetMeasuresMutation,
    useExecutePreviewMutation,
    useSaveAsNewVUMutation,
} from '../../Redux/VisualUnits/visualUnitAPISlice'
import {
    getVUDimensionColObject,
    getVUDimensionRowObject,
    getVUFilterableObject,
    getVUMeasureObject,
    parseFilterValueAndOptions,
} from '../../Pages/Workspace/workspace'
import { getMessageStatusFieldMsg, IFilterConditions, isAddParmsCall, updateDisplayOrder } from '../VuParamsHelpers'
import { FoundationsEnums } from '../../enum'
import Dialog from '../../GenericComponents/dialog'
import VisualUnitParamsDialog from './VisualUnitParamsDialog'
import {
    getMeasureListForVUID,
    getVUChartSettingsObject,
    getVUChartSwitchObject,
    isSummary,
    isTable,
} from '../../VisualunitHelpers'
import {
    IVUParamsSubCategory,
    useGetStratifiesMutation,
} from '../../Redux/VisualUnits/vuParamSlice'
import {
    buildDimensionColParameter,
    buildDimensionRowParameter,
    buildFilterableParameter,
    buildMeasureParameter,
    getVisualUnitParamsIndex,
} from '../../VisualunitHelpers'
import MeasureFrame from '../VisualUnitParams/MeasureFrame'
import FilterFrame from '../VisualUnitParams/FilterFrame'

import { useDeleteVisualUnitMutation, useFetchExecutePayloadMutation } from '../../Redux/ReportActions/reportActionsSlice'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import {VisualUnitApiDTO_EditSaveVisualUnit} from '../../Interfaces/APIContracts/VisualUnitApiDTO_EditSaveVisualUnit'
// import {OperationStatusContext} from '../Reports/VisualUnitFrame'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { FoundationsConstants } from '../../FoundationsConstants'
import ErrorBlock from '../ValidationsErrorBlock'
import DimensionFrame from '../VisualUnitParams/DimensionFrame'
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit'
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace'
import { useWorkspaceStore } from '../../Pages/Workspace/workspaceContext'
import { useApplyHighlight } from '../../GenericComponents/useApplyHighlight'
import { getCurrentUserData } from '../../Redux/store'
import { RootState } from '../../Redux/store'
export type TFilters = IFilters[]

export interface IFilters {
    filterableName: string
    filterableValueDisplay: string
    vuId: number
    vuIndex: number
    filterableIndex: number
    metaDataId: number
    filterOptions: string
    MetaData: any
    filterValueListId: number | string
}
export interface IFormedMeasurePayload {
    aggregateFunction: string
    axisSubType: number
    businessParameterId: number
    categoryName: string
    compCategoryName: string[]
    displayOrder: number
    factGroup: string[]
    id: number
    singleValueReportId: number
    measureSetId?: number
}
export type TMeasures = Imeasures[]

export interface Imeasures {
    measureName: string
    aggegrateFunctionName: string
    measureDescription: string
    vuId: number
    vuIndex: number
    measure_index: number
    metaDataId: number
    categoryName: string
    MetaData: IVUParamsSubCategory | undefined
}

export type TDimensionsRow = IDimensionsRow[]

export interface IDimensionsRow {
    dimensionName: string
    binName: string
    vuId: number
    vuIndex: number
    dimensionRowIndex: number
    metaDataId: number
    MetaData: any
    MetaDataBinId: number
}
export type TDimensionsCol = IDimensionsCol[]

export interface IDimensionsCol {
    dimensionName: string
    binName: string
    vuId: number
    vuIndex: number
    dimensionColIndex: number
    metaDataId: number
    MetaData: any
    MetaDataBinId: number
}

export type T_VuParamsActionState =
    | 'addmeasure'
    | 'addfilter'
    | ''
    | 'addrow'
    | 'addcolumn'
    | 'updateMeasure'
    | 'updateFilter'
    | 'updateRow'
    | 'updateColumn'

const DashboardVUParams = (props: {
    dashboardId: number
    tempVuData: VisualUnitApiDTO_VisualUnit_Extended
    setTempVuData: (vu: VisualUnitApiDTO_VisualUnit_Extended) => void
    setIsExplore: (key: boolean) => void
    onEditSave: () => void
    operationMode?: string
    onVisibilityChange?: any
    refreshVisualUnit: () => void
    operationStatusMessage: string
    setOperationStatusMessage: (message: string) => void
}) => {
    const {
        dashboardId,
        tempVuData,
        operationMode,
        setTempVuData,
        setIsExplore,
        onEditSave,
        refreshVisualUnit,
        setOperationStatusMessage
    } = props
    const dispatch = useDispatch()
    const [isParamsLoading, setIsParamsLoading] = useState(false) //this is used when we are showing Loading... when we launch Edit pallet.s
    const [callExecutePreview] = useExecutePreviewMutation()
    const [isParamsRefreshing, setIsParamsRefreshing] = useState(false) //FP-1627 this used when We are showing refresh beside Build query / refresh button
    const [fieldErrors, setFieldErrors] = useState<string[]>([])
    const [addAction, setAddAction] = useState<T_VuParamsActionState>('')
    const [updatePayload, setUpdatePayload] = useState<any>(null)
    const [callGetParams] = useGetVUParamsMutation()
    const [callGetMeasures] = useGetMeasuresMutation()
    const [callGetDimensionRowList] = useGetStratifiesMutation()
    const [callGetFilters] = useGetFiltersMutation()
    const [filterList, setFilterList] = useState<any[]>([])
    const [availMeasures, setAvailMeasures] = useState<TMeasures>([])
    const [availFilters, setAvailFilters] = useState<TFilters>([])
    const [availRows, setAvailRows] = useState<TDimensionsRow>([])
    const [availCols, setAvailCols] = useState<TDimensionsCol>([])
    const [measureList, setMeasureList] = useState<any[]>([])
    const [dimensionRowList, setDimensionRowList] = useState<any[]>([])
    const [groupedMeasures, setGroupedMeasures] = useState<any>({})
    const [categories, setCategories] = useState<string[]>([])
    const vuObjDataInfoFromStore = useSelector(getVuObjInfoState)
    const vuObjParamsFromStore = useSelector(getVUParamsInfoState)
    const [deleteNewlyAddedVU, setDeleteNewlyAddedVU] = useState(false)
    const [execDeleteVisualUnit] = useDeleteVisualUnitMutation()
    const [isSaveAllowed, setIsSaveAllowed] = useState(false)

    const [showSaveandSaveAs, setShowSaveandSaveAs] = useState(true)
    const [vuObj, setVuObj] = useState<string>(JSON.stringify(vuObjDataInfoFromStore)) //getting error that obj cannot accessible and cannot modify object, so to create deep copy later taken stringified object
    const [vuParams, setVuParams] = useState(vuObjParamsFromStore)
    const [vuDataObj, setVuDataObj] = useState({
        explore: '',
        tempViewerType: 1,
        refineMode: false,
        skipOldRendering: false,
        vuTempId: -1,
    })
    const [isSaveAsDialogOpen, setisSaveAsDialogOpen] = useState(false)
    const [saveAsNewVU] = useSaveAsNewVUMutation()
    const vuId = tempVuData.VisualUnitId
    const {applyHighlight, highlightClass } = useApplyHighlight(FoundationsConstants.APPLY_HIGHLIGHT_DURATION);
    const [editSettingsformData, seteditSettingsformData] = useState({
        name: '',
        description: '',
        autoRefresh: '0',
        accessLevel: '0',
        allowDrillThru: 'Y',
        drillThruPageSize: '10',
        autoNext: false,
    })
    let updateIndexRef: MutableRefObject<null | number> = useRef(null)

    const [executepayload] = useFetchExecutePayloadMutation()

    useEffect(() => {
        setIsParamsLoading(true)
        getFilters({ conditions: [{ conditionType: 'all', conditionData: null }] })
        getMeasures()
    }, [])

    useEffect(() => {
        //FP-12106
        if (fieldErrors.length > 0) {
            applyHighlight('vu_params_error', 'applyHighLight', {autoHide: false})
        }
    }, [fieldErrors])
 
    const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);
    const bulkUpdateVUs = useWorkspaceStore((s) => s.updateVisualUnits);

    const executeShowVisualUnitParams = (
        vuId: number,
        measureList: any[] = [],
        FilterListFetched: any[] = []
    ) => {
        let reqGetVUParams = {
            dashBoardId: dashboardId,
            visualUnitId: vuId,
        }
        //dispatch
        setVuDataObj({ ...vuDataObj, explore: 'yes' })
        // let isSingleVU = isSingleVU(vuId) || tempData.isSingleVU;

        callGetParams(reqGetVUParams)
            .unwrap()
            .then((response) => {
                // let paramsData = [];
                setVuDataObj({ ...vuDataObj, explore: 'yes' })
                let measuresParamsData: any = []
                let filtersParamsData: any = []
                let xAxisParamsData: any = []
                let yAxisParamsData: any = []
                let paramsFromStore: any = [...vuParams]
                let VuObjInfoFromStore: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(vuObj)]
                //.measures
                const resultData = response.data
                if (response.statusCode == 200) {
                    let vuParamsInfo = resultData.vuParams
                    setIsSaveAllowed(resultData?.saveAllowed)
                    if (vuParamsInfo) {
                        let vuIndex = getVisualUnitParamsIndex(vuId, vuObjDataInfoFromStore)
                        let indexedParams = { ...paramsFromStore[vuIndex] }
                        indexedParams.params = vuParamsInfo
                        let indexedVuObj = { ...VuObjInfoFromStore[vuIndex] }
                        VuObjInfoFromStore[vuIndex] = {
                            ...indexedVuObj,
                            name: vuParamsInfo?.Name || '',
                            description: vuParamsInfo?.Description || '',
                            refreshInterval: vuParamsInfo?.RefreshInterval || null,
                            privacyLock: vuParamsInfo?.PrivacyLock || false,
                            measures: [],
                            filterable: [],
                            dimensionCol: [],
                            dimensionRow: [],
                        }
                        vuParamsInfo?.MeasureList?.forEach(
                            (measure_value: any, measure_index: any) => {
                                let vuMeasureObj = getVUMeasureObject()
                                vuMeasureObj.id = parseInt(measure_value.MetaDataId)
                                vuMeasureObj.displayOrder = parseInt(measure_value.DisplayOrder)
                                vuMeasureObj.aggregateFunction = measure_value.AggregateFunctionName
                                vuMeasureObj.axisSubType = parseInt(measure_value?.AxisSubType)
                                vuMeasureObj.businessParameterId = parseInt(
                                    measure_value.BusinessParameterId
                                )
                                vuMeasureObj.singleValueReportId = parseInt(
                                    measure_value.SingleValueReportId
                                )
                                vuMeasureObj.factGroup = []
                                vuMeasureObj.compCategoryName = []
                                measureList.forEach((itr, ind: number) => {
                                    if (vuMeasureObj.id === itr?.FieldKey) {
                                        vuMeasureObj.compCategoryName.push(
                                            ...itr?.ComputedCategoryName
                                        )
                                        vuMeasureObj.factGroup.push(...itr?.FactGroupName)
                                        return
                                    }
                                })
                                VuObjInfoFromStore[vuIndex].measures[measure_index] = vuMeasureObj
                                let aggregateFunctionName = ''
                                let measureDescription = ''
                                if (measure_value?.BusinessParameter) {
                                    measureDescription =
                                        measure_value.BusinessParameter.Name +
                                        ' (' +
                                        measure_value.BusinessParameter.BPValue +
                                        ')'
                                } else if (measure_value.SingleValueReport != null) {
                                    measureDescription =
                                        measure_value.SingleValueReport.Name +
                                        ' (' +
                                        (measure_value.SingleValueReport.Description == ''
                                            ? '-no desc-'
                                            : measure_value.SingleValueReport.Description) +
                                        ')'
                                } else {
                                    aggregateFunctionName = measure_value.AggregateFunctionName
                                }
                                let measureParamObj = buildMeasureParameter(
                                    vuId,
                                    vuIndex,
                                    measure_index,
                                    measure_value.MetaDataId,
                                    measure_value.MetaData.FieldName,
                                    aggregateFunctionName,
                                    measureDescription,
                                    measure_value?.MetaData?.CategoryName,
                                    measure_value?.MetaData
                                )
                                measuresParamsData.push(measureParamObj)
                            }
                        )
                        vuParamsInfo.FilterableList.forEach(
                            (filterable_value: any, filterable_index: number) => {
                                let vuFilterableObj: any = getVUFilterableObject()
                                vuFilterableObj.id = parseInt(filterable_value.MetaDataId)
                                vuFilterableObj.displayOrder = parseInt(
                                    filterable_value.DisplayOrder
                                )
                                vuFilterableObj.filterValue = filterable_value.FilterValue
                                vuFilterableObj.filterValueListId =
                                    filterable_value._internal_types_filterlookup //healthLevelGlobal.parseInteger(filterable_value.FilterValueListId);
                                vuFilterableObj.filterDisplayText =
                                    filterable_value.FilterDisplayText
                                vuFilterableObj.InputFilterType = filterable_value.InputFilterType
                                switch (filterable_value.MetaData.DataType) {
                                    case FoundationsEnums.HLDataType.HLList:
                                    case FoundationsEnums.HLDataType.HLSearchList:
                                        let valueAndOptions = parseFilterValueAndOptions(
                                            filterable_value.FilterValue
                                        )
                                        vuFilterableObj.filterValue = valueAndOptions.filterValue
                                        vuFilterableObj.filterOptions =
                                            valueAndOptions.filterOptions == ''
                                                ? 'INCLUDE_ANY'
                                                : valueAndOptions.filterOptions
                                        break
                                }
                                VuObjInfoFromStore[vuIndex].filterable[filterable_index] =
                                    vuFilterableObj

                                let filterableParamObj = buildFilterableParameter(
                                    vuId,
                                    vuIndex,
                                    filterable_index,
                                    filterable_value.MetaDataId,
                                    filterable_value.MetaData.FieldName,
                                    filterable_value.FilterDisplayText,
                                    vuFilterableObj.filterOptions,
                                    filterable_value.MetaData,
                                    vuFilterableObj.filterValue,
                                    vuFilterableObj.filterValueListId
                                )
                                filtersParamsData.push(filterableParamObj)
                            }
                        )
                        vuParamsInfo?.XAxisList.forEach((xaxis_value: any, xaxis_index: number) => {
                            let vuDimRowObj = getVUDimensionRowObject()
                            vuDimRowObj.id = parseInt(xaxis_value.MetaDataId)
                            vuDimRowObj.displayOrder = parseInt(xaxis_value.DisplayOrder)
                            vuDimRowObj.metaDataBinId = parseInt(xaxis_value.MetaDataBin.Id)
                            VuObjInfoFromStore[vuIndex].dimensionRow[xaxis_index] = vuDimRowObj

                            let binName = ''
                            if (xaxis_value.MetaDataBin.Id == 0) {
                                binName = '- no bin -'
                            } else {
                                binName = xaxis_value.MetaDataBin.Name
                            }

                            let dimRowParamObj = buildDimensionRowParameter(
                                vuId,
                                vuIndex,
                                xaxis_index,
                                xaxis_value.MetaDataId,
                                xaxis_value.MetaData.FieldName,
                                binName,
                                xaxis_value.MetaData?.CategoryName,
                                xaxis_value?.MetaData,
                                xaxis_value.MetaDataBin.Id
                            )
                            xAxisParamsData.push(dimRowParamObj)
                        })

                        vuParamsInfo?.YAxisList.forEach((yaxis_value: any, yaxis_index: number) => {
                            let vuDimColObj = getVUDimensionColObject()
                            vuDimColObj.id = parseInt(yaxis_value.MetaDataId)
                            vuDimColObj.displayOrder = parseInt(yaxis_value.DisplayOrder)
                            vuDimColObj.metaDataBinId = parseInt(yaxis_value.MetaDataBin.Id)
                            VuObjInfoFromStore[vuIndex].dimensionCol[yaxis_index] = vuDimColObj

                            let binName = ''
                            if (yaxis_value.MetaDataBin.Id == 0) {
                                binName = '- no bin -'
                            } else {
                                binName = yaxis_value.MetaDataBin.Name
                            }

                            let dimColParamObj = buildDimensionColParameter(
                                vuId,
                                vuIndex,
                                yaxis_index,
                                yaxis_value.MetaDataId,
                                yaxis_value.MetaData.FieldName,
                                binName,
                                yaxis_value.MetaData?.CategoryName,
                                yaxis_value?.MetaData,
                                yaxis_value.MetaDataBin.Id
                            )
                            yAxisParamsData.push(dimColParamObj)
                        })
                    }
                }
                setVuObj(JSON.stringify(VuObjInfoFromStore))

                dispatch(setVuObjectInfoStore({ data: VuObjInfoFromStore }))
                setAvailMeasures(measuresParamsData)
                setAvailFilters(filtersParamsData)
                setAvailRows(xAxisParamsData)
                setAvailCols(yAxisParamsData)
                setIsParamsLoading(false)
            })
    }

    const handleSaveAsParams = () => {
        setisSaveAsDialogOpen(true)
    }
    const handleSaveAsNewReport = (vuId: number) => {
        let vuObjParsed: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(vuObj)]
        const measureFilterList = getMeasureListForVUID(
            vuId,
            vuObjDataInfoFromStore,
            vuParams,
            vuObjParsed,
            tempVuData.MeasureList,
            setVuObj,
            tempVuData
        )
        const currentlist = measureFilterList.filter((item: any) => item.id === vuId)
        const reqVisualUnitData = {
            viewerType: tempVuData.ViewerType,
            refreshInterval:
                editSettingsformData.autoRefresh == '' || editSettingsformData.autoRefresh == null
                    ? tempVuData.RefreshInterval
                    : editSettingsformData.autoRefresh,
            privacyLock: editSettingsformData.accessLevel,
            preview: tempVuData.Preview,
            name: editSettingsformData.name,
            measures: currentlist[0]?.measures,
            id: vuId,
            filterable: currentlist[0]?.filterable,
            drillthrusetId: -1,
            dimensionRow: currentlist[0]?.dimensionRow,
            dimensionCol: currentlist[0]?.dimensionCol,
            descriptionString: '',
            description: editSettingsformData.description,
            DashBoardId: props.dashboardId,
            changeddrillthruset: false, //need to set through method
            allowDrillThru:
                editSettingsformData.allowDrillThru == '' ||
                    editSettingsformData.allowDrillThru == null
                    ? tempVuData.AllowDrillThru
                    : editSettingsformData.allowDrillThru,
            IsEnabledAutoNavigation: editSettingsformData.autoNext
                ? tempVuData.IsEnabledAutoNavigation
                : editSettingsformData.autoNext,
            DrillthruPageSize: editSettingsformData.drillThruPageSize,
        }
        saveAsNewVU(reqVisualUnitData)
            .unwrap()
            .then((response) => {
                let resultData = response?.data
                setIsExplore(false)

                executepayload({ wsid: dashboardId, Id: resultData.newVisualUnitId }).unwrap().then((new_vu_response) => {
                    let updatedVUList = [...currentWorkspaceData.VisualUnits]
                    updatedVUList.push({...(new_vu_response.data) });
                    bulkUpdateVUs(updatedVUList)
                })

                for (let i = 0; i < resultData.MessageResults.length; i++) {
                    if (
                        resultData.MessageResults[i].HelpMessage == FoundationsEnums.Status.Success
                    ) {
                        setisSaveAsDialogOpen(false)
                        FoundationsGenericToaster('success', resultData.MessageResults[i].Message)
                        //Handle below commented code : TODO
                        //   var vuDrillDataObj = $("#vu_table_drill_" + vuId);
                        //   var ChangeddrillThruSetId = $(vuDrillDataObj).data("data_currentchangeddrillthruset");
                        //   var olddrillThruSetId = $(vuDrillDataObj).data("data_olddrillThruSetId");
                        //   if (ChangeddrillThruSetId != undefined && olddrillThruSetId != undefined) {
                        //       if (ChangeddrillThruSetId !== olddrillThruSetId && olddrillThruSetId !== -1) {
                        //           unicornInstance.toastr('success', 'Assigned the selected drill view for this ' + healthLevelWorkspace.enumVULabel.SingularLower + ' successfully.');
                        //       }
                        //   }
                    } else {
                        FoundationsGenericToaster('error', resultData.MessageResults[i].Message)
                    }
                }
            })
    }
    const deleteClicked = () => {
        const formData = new FormData()
        formData.append('DashboardId', '' + props.dashboardId)
        formData.append('VisualUnitId', vuId.toString())
        formData.append('privacyLock', tempVuData.PrivacyLock)

        execDeleteVisualUnit(formData)
            .unwrap()
            .then((response: any) => {
                
                let newVUSList = [...currentWorkspaceData.VisualUnits]
                newVUSList = newVUSList.filter(x => x.VisualUnitId != vuId)
                bulkUpdateVUs(newVUSList)

                setDeleteNewlyAddedVU(false)
                props.onVisibilityChange(false)
                FoundationsGenericToaster('success', `Report has been deleted permanently.`)
            })
            .catch((error: any) => {
                console.error('Error deleting visual unit:', error)
                FoundationsGenericToaster('error', `Error deleting visual unit.`)
            })
    }
    const handleChange = (field: any, value: any) => {
        seteditSettingsformData((prevState) => ({
            ...prevState,
            [field]: typeof value === 'boolean' ? value : value,
        }))
    }

    const refreshParamsClicked = () => {
        setIsParamsRefreshing(true)
        //exploreTempVUId
        let vuIndex = getVisualUnitParamsIndex(vuId, vuObjDataInfoFromStore)
        let isExplore = vuDataObj.explore === 'yes' ? true : false
        // let chartSwitch: any = getVUChartSwitchObject()
        // let chartSettings: any = getVUChartSettingsObject()
        let chartSwitch: any = tempVuData?.ChartSwitch
        let chartSettings: any = tempVuData?.ChartSettings
        let tableSettings: any = {}
        let tempvuIdAlreadyInExploreMode = vuDataObj.vuTempId
        let viewer_type = tempVuData.ViewerType
        if (isExplore) {
            chartSwitch = tempVuData?.ChartSwitch
            chartSettings = tempVuData?.ChartSettings
            tableSettings = tempVuData?.TableSettings
            if (tempvuIdAlreadyInExploreMode === null || tempvuIdAlreadyInExploreMode === -1) {
                tempvuIdAlreadyInExploreMode = -1
                // viewer_type = tempVuData?.viewerType ? tempData.tempViewerType : tempVuData?.viewerType
                if (!viewer_type) {
                    viewer_type = FoundationsEnums.VisualUnitViewerType.Table
                }
                chartSettings =
                    chartSettings?.ApplySettings === true
                        ? tempVuData?.ChartSettings
                        : tempVuData.ChartSettings
                chartSwitch =
                    chartSwitch?.ApplySwitchValues == true
                        ? tempVuData?.ChartSwitch
                        : tempVuData.ChartSwitch
                tableSettings =
                    tableSettings != undefined && tableSettings.ApplySettings == true
                        ? tempVuData?.TableSettings
                        : tempVuData?.TableSettings
            } else {
                chartSwitch = tempVuData.ChartSwitch
                chartSettings = tempVuData.ChartSwitch
                if (!viewer_type) {
                    viewer_type = FoundationsEnums.VisualUnitViewerType.Table
                }
            }
            // specific vuObject 
            let indexedVuOj: VisualUnitApiDTO_EditSaveVisualUnit = { ...updateDisplayOrder(JSON.parse(vuObj)[vuIndex]) }
            // all vu objects in store
            let indexedDataObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(vuObj)]
            if (indexedVuOj.dimensionRow.length === 0 && indexedVuOj.dimensionCol.length === 0) { //Since we are not allowing Params with -1 id, Directly checking for its length
                viewer_type = FoundationsEnums.VisualUnitViewerType.SVU
            } else if (isSummary(tempVuData)){ //if the VU has an organizer but is set to summary viewerType then switch to table
                viewer_type = FoundationsEnums.VisualUnitViewerType.Table
            }
            indexedDataObj[vuIndex] = {...indexedVuOj, viewerType:viewer_type}
            dispatch(setVuObjectInfoStore({ data: indexedDataObj })) //keep viewertype consistent with table/summary
            
            let clientPreViewDtoRequest: any = {
                ...indexedVuOj,
                VisualUnitId: vuId,
                viewerType: viewer_type, // we are correctly passing viewre type...
                chartSwitch: chartSwitch,
                chartSettings: chartSettings,
                tableSettings: tableSettings,
                exploreTempVUId: tempVuData.TempVisualUnitId,
                refineMode: false,
                privacyLock: tempVuData.PrivacyLock,
                refreshInterval: tempVuData.RefreshInterval,
            }
            if (indexedVuOj.measures.length === 0) {
                setOperationStatusMessage('Please add at least one measure.')
                setIsParamsRefreshing(false)
                return
            } else if (indexedVuOj.filterable.length === 0) {
                setOperationStatusMessage(
                    'Please add at least one filter, typically with a date range, such as Date of Service.'
                )
                setIsParamsRefreshing(false) //no need of api call if filterable/ measures are empty
                setShowSaveandSaveAs(true)
                return
            } else {
                setOperationStatusMessage("") //FIXME: Need to handle in more efficient way
                redrawVisualUnitParams(clientPreViewDtoRequest, undefined, viewer_type)
            }
        }
    }

    const redrawVisualUnitParams = (
        clientPreViewDtoRequest: any,
        refineMode: any,
        viewertype: number
    ) => {
        callExecutePreview(clientPreViewDtoRequest)
            .unwrap()
            .then((response) => {
                if (response) {
                    let resultData = response?.data

                    if (resultData) {
                        setShowSaveandSaveAs(true)
                        let tempVisualUnitId = resultData.TempVisualUnitId

                        for (let i = 0; i < resultData.MessageResults.length; i++) {
                            if (
                                resultData.MessageResults[i].HelpMessage ==
                                FoundationsEnums.Status.Success
                            ) {
                                setVuDataObj((prev: any) => ({
                                    ...prev,
                                    vuTempId: tempVisualUnitId,
                                }))
                                if (
                                    viewertype !== FoundationsEnums.VisualUnitViewerType.ActivePanel
                                ) {
                                    setTempVuData({
                                        ...tempVuData,
                                        ViewerType: viewertype, // check if we need to convert to summary 
                                        TempVisualUnitId: tempVisualUnitId,
                                        BuildQuery: clientPreViewDtoRequest?.BuildQuery ?? false,
                                        XAxisList: clientPreViewDtoRequest?.dimensionRow ?? [],
                                        YAxisList: clientPreViewDtoRequest?.dimensionCol ?? [],
                                        MeasureList: clientPreViewDtoRequest?.measures ?? [],
                                        FilterableList: clientPreViewDtoRequest?.filterable ?? [],
                                        // applyChange: true,
                                    })

                                    setIsParamsRefreshing(false)
                                    setIsParamsLoading(false)
                                } else {
                                    console.error('Preview for active panel not enabled')
                                }
                                setFieldErrors([])
                                setOperationStatusMessage('');
                            } else {
                                let messageStatus = resultData.MessageResults[i]
                                let paramErrorString = []
                                let measureError = getMessageStatusFieldMsg(
                                    messageStatus,
                                    'VisualUnitMeasure'
                                )
                                if (measureError !== '') {
                                    setOperationStatusMessage(measureError)
                                    setIsParamsRefreshing(false)
                                    setIsParamsLoading(false)
                                    return
                                }
                                let filterError = getMessageStatusFieldMsg(
                                    messageStatus,
                                    'VisualUnitFilter'
                                )
                                if (filterError != '') {
                                    paramErrorString.push(filterError)
                                }
                                let dimXAxisError = getMessageStatusFieldMsg(
                                    messageStatus,
                                    'VisualUnitDimensionXAxis'
                                )
                                if (dimXAxisError != '') {
                                    paramErrorString.push(dimXAxisError)
                                }
                                let dimYAxisError = getMessageStatusFieldMsg(
                                    messageStatus,
                                    'VisualUnitDimensionYAxis'
                                )
                                if (dimYAxisError != '') {
                                    paramErrorString.push(dimYAxisError)
                                }
                                let dimDimensionError = getMessageStatusFieldMsg(
                                    messageStatus,
                                    'VisualUnitDimension'
                                )
                                if (dimDimensionError != '') {
                                    paramErrorString.push(dimDimensionError)
                                }
                                if (paramErrorString.length > 0) {
                                    //FP-10377. Only show below html element if data is available.
                                    setFieldErrors(paramErrorString)
                                } else if (!measureError) {
                                    refreshVisualUnit()
                                }
                                if (messageStatus?.Message) {
                                    const trimmedMessage = messageStatus.Message.trim().toLowerCase();

                                    const isFieldErrorEmpty =
                                        trimmedMessage === 'same dimension (with same binning) cannot be present in row and column.' ||
                                        trimmedMessage === 'duplicate dimensions are not allowed.';

                                    if (isFieldErrorEmpty) {
                                        setOperationStatusMessage(messageStatus.Message);
                                        setFieldErrors([]);
                                    } else {
                                        setFieldErrors(paramErrorString);
                                    }
                                }

                                setIsParamsRefreshing(false)
                                setIsParamsLoading(false)
                            }
                        }
                    }
                }
            })
    }

    const getMeasures = async () => {
        let measuresList: any = []
        try {
            measuresList = await callGetMeasures([]).unwrap()
            if (measureList) {
                executeShowVisualUnitParams(vuId, measuresList.data) // measure api calling 2 times so moved here..
            }
        } catch (err) {
            console.error('error from getting measure list', err)
        }
        setMeasureList(measuresList?.data || [])
        return measuresList?.data || []
    }
    const getStratifiesPromise = async (metadataPayload: { conditions: IFilterConditions[] }) => {
        setIsParamsRefreshing(true)
        Promise.resolve(getStratifies(metadataPayload))
            .then((response: any) => {
                fillParamsListTable(response)
                //FP-11949 Moved setIsParamsRefreshing(false) & setOpenVUParamsDialog(true) to fillParamsListTable method
            })
            .catch((err) => {
                setIsParamsRefreshing(false)
                console.error('error in getting Dimension list..', err)
            })
    }
    const getFilterPromise = async (metadataPayload: { conditions: IFilterConditions[] }) => {
        setIsParamsRefreshing(true)
        Promise.resolve(getFilters(metadataPayload))
            .then((response: any) => {
                fillParamsListTable(response)
            })
            .catch((err) => console.error('error in getting Filter list..', err))
    }

    const getStratifies = async (metadataPayload: any) => {
        let dimRowList: any = []
        try {
            dimRowList = await callGetDimensionRowList(metadataPayload).unwrap()
        } catch (err) {
            console.error('error from getting Dimension Row List', err)
        }
        setDimensionRowList(dimRowList?.data || [])
        return dimRowList?.data
    }
    const getFilters = async (metadataPayload: { conditions: IFilterConditions[] }) => {
        let filterList: any = []
        // let initialFilterPayload = { conditions: [{ conditionType: 'all', conditionData: null }] }
        try {
            filterList = await callGetFilters(metadataPayload).unwrap()
        } catch (err) {
            console.error('error from getting Filters')
        }
        setFilterList(filterList?.data || [])
        return filterList?.data || []
    }
    const [openVUParamsDialog, setOpenVUParamsDialog] = useState(false)

    const getHLMetadata = (metadata: any, metadataPayload: { conditions: IFilterConditions[] }) => {
        //function is triggering from Metadata Pallet dialog
        if (metadata === 'filter') {
            getFilterPromise(metadataPayload)
        } else {
            getStratifiesPromise(metadataPayload)
        }
    }

    const fillParamsListTable = (sourceList: any[]) => {
        let categoryNames: any[] = []
        let sortedList = [...sourceList].sort(function (a, b) {
            return a.FieldName > b.FieldName ? 1 : -1
        })

        sortedList.forEach((measure_value: any, measure_index: number) => {
            if (categoryNames.indexOf(measure_value.CategoryName) === -1) {
                categoryNames.push(measure_value.CategoryName)
            }
        })
        let groupedCategories: any = Object.groupBy([...sourceList], ({ CategoryName }) => CategoryName) //creating a shallow copy, as react throwing error

        if (Object.keys(groupedCategories).length > 0) { //FP-11949- Doing inner sort based on FieldName
            Object.keys(groupedCategories).forEach(category => {
                groupedCategories[category].sort((a: any, b: any) =>
                    a.FieldName.localeCompare(b.FieldName)
                );
            });
        }

        setGroupedMeasures(groupedCategories)
        let soretedCategories = categoryNames.sort((a: string, b: string) => {
            return a > b ? 1 : -1
        })
        setCategories(soretedCategories)
        setTimeout(() => {
            setOpenVUParamsDialog(true)
            setIsParamsRefreshing(false)
        }, 500) //FP-11949 - adding small delay because some times, list is showing empty in dialog then its being set.
    }

    let CopyOfVuObjInfoFromStore: VisualUnitApiDTO_EditSaveVisualUnit[] = Array.isArray(vuObj)
                                                ? [...vuObj]
                                                : [...JSON.parse(vuObj)];
    let vuIndex = getVisualUnitParamsIndex(vuId, CopyOfVuObjInfoFromStore)

    //FP-12098- UseEffect to display/clear FieldError are removed, its behaviour was uncontrolled, used displayFieldErrors instead

    const displayFieldErrors = (addedCount: number,
        callFrom: "add" | "save",
        action: "measure" | "dimensionRow" | "dimensionColumn") => {
        if (callFrom !== "add") {
            setFieldErrors([]);
            return;
        }
        const limits: Record<typeof action, { limit: number; message: string }> = {
            measure: {
                limit: FoundationsConstants.ALLOWED_MEASURES,
                message: 'Sorry, only five measures allowed (for now).',
            },
            dimensionRow: {
                limit: FoundationsConstants.ALLOWED_DIMENSIONS,
                message: 'Sorry, only two organize rows allowed (for now).',
            },
            dimensionColumn: {
                limit: FoundationsConstants.ALLOWED_DIMENSIONS,
                message: 'Sorry, only two organize columns allowed (for now).',
            }
        };

        const config = limits[action];

        if (config) {
            if (addedCount === config.limit) {
                setFieldErrors([config.message]);
            } else if (addedCount < config.limit) {
                setFieldErrors([]);
            }
        }
    };


    const addNewMeasure = (
        vuId: number,
        vuIndex: number,
        refineMode: boolean = false,
        showMeasureDialog: boolean = true,
        callFor: T_VuParamsActionState = 'addmeasure',
        payload: any = null,
        updateIndexCall: number | null = null
    ) => {
        setFieldErrors([])
        updateIndexRef.current = updateIndexCall
        setIsParamsRefreshing(true)
        setAddAction(callFor)
        setUpdatePayload(payload)
        let addMeasure = false
        let measureIndex = -1
        //action

        let measuresCount = CopyOfVuObjInfoFromStore[vuIndex]?.measures?.length
        let isMeasure = callFor === 'addmeasure'
        if (isMeasure && measuresCount == FoundationsConstants.ALLOWED_MEASURES) {
            setIsParamsRefreshing(false)
            setFieldErrors(['Sorry, only five measures allowed (for now).'])
            return
        }

        CopyOfVuObjInfoFromStore.forEach((measure_value: any, measure_index: number) => {
            if (measure_value?.id == -1) {
                measureIndex = measure_index
                addMeasure = true
                return false
            }
        })

        if (measureIndex == -1 && measuresCount <= FoundationsConstants.ALLOWED_MEASURES) {
            measureIndex = measuresCount
            addMeasure = true
        }

        if (addMeasure) {
            fillParamsListTable(measureList)
            //showMeasureDialog variable is not in use and its true always
        } else {
            setIsParamsRefreshing(false)
        }
    }

    const addMeasureFromDialog = (dialogProps: any, callFrom: "add" | "save") => {
        let vuIndex = getVisualUnitParamsIndex(vuId, vuObjDataInfoFromStore)
        let indexedDataObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(vuObj)]

        switch (addAction) {
            case 'updateMeasure':
            case 'addmeasure':
                let formedMeasureForApi = getVUMeasureObject()
                formedMeasureForApi.aggregateFunction = dialogProps.aggregateFunction
                formedMeasureForApi.compCategoryName = dialogProps.compCategoryName
                formedMeasureForApi.displayOrder = dialogProps.displayOrder
                formedMeasureForApi.factGroup = dialogProps.factGroup
                formedMeasureForApi.id = dialogProps.id
                formedMeasureForApi.singleValueReportId = 0
                formedMeasureForApi.measureSetId = dialogProps.measureSetId

                if (dialogProps.axisSubType === FoundationsEnums.AxisSubType.BP) {
                    formedMeasureForApi.aggregateFunction = 'None'
                    formedMeasureForApi.businessParameterId = dialogProps.businessParameterId
                    formedMeasureForApi.axisSubType = dialogProps.axisSubType
                }
                if (dialogProps.axisSubType === FoundationsEnums.AxisSubType.SVR) {
                    formedMeasureForApi.aggregateFunction = 'None'
                    formedMeasureForApi.singleValueReportId = dialogProps.singleValueReportId
                    formedMeasureForApi.axisSubType = dialogProps.axisSubType
                }
                let formedAvailMeasure: Imeasures = {
                    aggegrateFunctionName: dialogProps.aggregateFunction,
                    measureDescription: '',
                    measure_index: 0,
                    metaDataId: dialogProps.id,
                    vuId: vuId,
                    vuIndex: vuIndex,
                    measureName: dialogProps.subCategoryName,
                    categoryName: dialogProps.categoryName,
                    MetaData: dialogProps?.MetaData,
                }

                let currentMeasureList = [...availMeasures]
                if (updateIndexRef.current !== null) {
                    //this is update call
                    currentMeasureList[updateIndexRef.current] = formedAvailMeasure
                    indexedDataObj[vuIndex].measures[updateIndexRef.current] = formedMeasureForApi
                    // setAvailMeasures(currentMeasureList)
                } else {
                    //this is add new call
                    indexedDataObj[vuIndex].measures.push(formedMeasureForApi)
                    currentMeasureList.push(formedAvailMeasure)
                }
                dispatch(setVuObjectInfoStore({ data: indexedDataObj })) //Storing added Params to store to use for Save, SaveAs func.
                setVuObj(JSON.stringify(indexedDataObj))
                 setShowSaveandSaveAs(false);
                setAvailMeasures(currentMeasureList)
                let currentMeasureCount = indexedDataObj[vuIndex].measures.length
                displayFieldErrors(currentMeasureCount, callFrom, "measure")
                break

            case 'addfilter':
            case 'updateFilter':
                let formedFiltrableForApi = getVUFilterableObject()
                formedFiltrableForApi.filterDisplayText = dialogProps.filterDisplayText
                formedFiltrableForApi.filterOptions = dialogProps.filterOptions
                formedFiltrableForApi.filterValue = dialogProps.filterValue
                formedFiltrableForApi.id = dialogProps.id
                formedFiltrableForApi.InputFilterType = dialogProps.InputFilterType
                formedFiltrableForApi.filterValueListId = dialogProps.filterValueListId
                formedFiltrableForApi.bpId = dialogProps?.bpId

                let filterableParamObj: IFilters = buildFilterableParameter(
                    vuId,
                    vuIndex,
                    0,
                    dialogProps.id,
                    dialogProps?.categoryName,
                    dialogProps.filterDisplayText,
                    dialogProps.filterOptions,
                    dialogProps.MetaData,
                    dialogProps.filterValue,
                    dialogProps.filterValueListId
                )
                let currentFilterList = [...availFilters]

                if (updateIndexRef.current !== null) {
                    //this is update call
                    currentFilterList[updateIndexRef.current] = filterableParamObj
                    indexedDataObj[vuIndex].filterable[updateIndexRef.current] =
                        formedFiltrableForApi
                } else {
                    //this is add new call
                    indexedDataObj[vuIndex].filterable.push(formedFiltrableForApi)
                    currentFilterList.push(filterableParamObj)
                }

                setAvailFilters(currentFilterList)
                setVuObj(JSON.stringify(indexedDataObj))
                 setShowSaveandSaveAs(false);
                dispatch(setVuObjectInfoStore({ data: indexedDataObj })) //No need of store call, will remove soon in store cleanup ticket..
                break

            case 'addcolumn':
            case 'updateColumn':
                let formedAvaildimensionsCol: IDimensionsCol = {
                    binName: dialogProps.binName,
                    dimensionName: dialogProps.dimensionName,
                    dimensionColIndex: 0,
                    metaDataId: dialogProps.metaDataId,
                    vuId: vuId,
                    vuIndex: vuIndex,
                    MetaData: dialogProps?.MetaData,
                    MetaDataBinId: dialogProps?.MetaDataBinId,
                }
                let formedDimColPayload = getVUDimensionColObject()
                formedDimColPayload.id = dialogProps.Id
                formedDimColPayload.metaDataBinId = dialogProps?.MetaDataBinId
                let currentColList = [...availCols]

                if (updateIndexRef.current !== null) {
                    //this is update call
                    currentColList[updateIndexRef.current] = formedAvaildimensionsCol
                    indexedDataObj[vuIndex].dimensionCol[updateIndexRef.current] =
                        formedDimColPayload
                } else {
                    //this is add new call
                    indexedDataObj[vuIndex].dimensionCol.push(formedDimColPayload)
                    currentColList.push(formedAvaildimensionsCol)
                }

                setAvailCols(currentColList)
                setVuObj(JSON.stringify(indexedDataObj))
                 setShowSaveandSaveAs(false);
                dispatch(setVuObjectInfoStore({ data: indexedDataObj }))
                let currentColumnCount = indexedDataObj[vuIndex].dimensionCol.length
                displayFieldErrors(currentColumnCount, callFrom, "dimensionColumn")
                break
            case 'addrow':
            case 'updateRow':
                let formedAvaildimensionsRow: IDimensionsRow = {
                    binName: dialogProps.binName,
                    dimensionName: dialogProps.dimensionName,
                    dimensionRowIndex: 0,
                    metaDataId: dialogProps.metaDataId,
                    vuId: vuId,
                    vuIndex: vuIndex,
                    MetaData: dialogProps?.MetaData,
                    MetaDataBinId: dialogProps.MetaDataBinId,
                }
                let formedDimRowPayload = getVUDimensionRowObject()
                formedDimRowPayload.id = dialogProps.Id
                formedDimRowPayload.metaDataBinId = dialogProps.MetaDataBinId
                // indexedDataObj[vuIndex].dimensionRow.push(formedDimRowPayload)
                let currentRowList = [...availRows]
                if (updateIndexRef.current !== null) {
                    //this is update call
                    currentRowList[updateIndexRef.current] = formedAvaildimensionsRow
                    indexedDataObj[vuIndex].dimensionRow[updateIndexRef.current] =
                        formedDimRowPayload
                    setAvailRows(currentRowList)
                } else {
                    //this is add new call
                    indexedDataObj[vuIndex].dimensionRow.push(formedDimRowPayload)
                    currentRowList.push(formedAvaildimensionsRow)
                    setAvailRows(currentRowList)
                }
                dispatch(setVuObjectInfoStore({ data: indexedDataObj }))

                // currentRowList.push(formedAvaildimensionsRowAPI)
                setVuObj(JSON.stringify(indexedDataObj))
                 setShowSaveandSaveAs(false);
                let currentRowCount = indexedDataObj[vuIndex].dimensionRow.length
                displayFieldErrors(currentRowCount, callFrom, "dimensionRow")
                // setAvailRows(currentRowList)
                break
        }

        // dispatch(setVuObjectInfoStore({ data: indexedDataObj }))
    }
    const addNewFilterable = (
        vuId: number,
        vuIndex: number,
        refineMode: boolean = false,
        showMeasureDialog: boolean = true,
        callFor: T_VuParamsActionState = 'addfilter',
        payload: any = null,
        updateIndexCall: number | null = null
    ) => {
        setFieldErrors([])
        setIsParamsRefreshing(true)
        let addFilter = false
        let filterIndex = -1
        updateIndexRef.current = updateIndexCall
        setAddAction(callFor)
        setUpdatePayload(payload)
        let copyOfVuObjInfoFromStore: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(vuObj)]
        let filterCount = copyOfVuObjInfoFromStore[vuIndex]?.filterable?.length
        copyOfVuObjInfoFromStore.forEach((filter_value: any, filter_index: number) => {
            if (filter_value?.id == -1) {
                filterIndex = filter_index
                addFilter = true
                return false
            }
        })

        if (filterIndex == -1 && filterCount < 6) {
            // copyOfVuObjInfoFromStore[vuIndex].filterable[filterCount] = getVUFilterableObject();
            filterIndex = filterCount
            addFilter = true
        }
        if (addFilter) {
            getFilterPromise({ conditions: [{ conditionType: 'all', conditionData: null }] })
        } else {
            setIsParamsRefreshing(false)
        }
    }

    const showDimensionListDialog = (
        vuId: number,
        vuIndex: number,
        refineMode: any = undefined,
        showDimensionDialog: boolean = true,
        type: T_VuParamsActionState,
        updatePayload: any = null,
        updateIndexCall: number | null = null
    ) => {
        setFieldErrors([])
        updateIndexRef.current = updateIndexCall
        setAddAction(type)
        setUpdatePayload(updatePayload)
        let addDimensionRow = false
        //Update Dimension Row is In progress..
        let dimensionIndex = -1
        let copyVuObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(vuObj)]
        let dimensionsRowCount = copyVuObj[vuIndex].dimensionRow.length
        let dimensionsColCount = copyVuObj[vuIndex].dimensionCol.length

        copyVuObj[vuIndex].dimensionRow.forEach((dimension_value, dimension_index) => {
            if (dimension_value?.id == -1) {
                dimensionIndex = dimension_index
                addDimensionRow = true
                return false
            }
        })
        if (type === 'addcolumn' || type === 'updateColumn') {
            addDimensionRow = true
            if (dimensionsColCount === FoundationsConstants.ALLOWED_DIMENSIONS && type === 'addcolumn') {
                addDimensionRow = false
                setFieldErrors(['Sorry, only two organize columns allowed (for now).'])
                setIsParamsRefreshing(false)
                return
            }
        }
        if (type === 'addrow' || type === 'updateRow') {
            addDimensionRow = true
            if (dimensionsRowCount === FoundationsConstants.ALLOWED_DIMENSIONS && type === 'addrow') {
                addDimensionRow = false
                setFieldErrors(['Sorry, only two organize rows allowed (for now).'])
                setIsParamsRefreshing(false)
                return
            }
        }

        // if ((dimensionIndex == -1) && (dimensionsRowCount < 2)) {
        //     // copyVuObj[vuIndex].dimensionRow[dimensionsRowCount] = getVUDimensionRowObject();
        //     dimensionIndex = dimensionsRowCount;
        //     addDimensionRow = true;
        // }

        if (addDimensionRow) {
            getStratifiesPromise({
                conditions: [{ conditionType: 'all', conditionData: null }],
            })
        }
    }

    const BuildQuery = () => {
        let viewerType = FoundationsEnums.VisualUnitViewerType.Table
        let vuIndex = getVisualUnitParamsIndex(vuId, vuObjDataInfoFromStore)
        let chartSwitch = getVUChartSwitchObject()
        let chartSettings: any = getVUChartSettingsObject()
        let tableSettings: any = {}
        let tempvuIdAlreadyInExploreMode
        let isExplore = 'yes' //buildQuery is always in editmode
        if (isExplore) {
            viewerType = viewerType
            chartSwitch = tempVuData?.ChartSwitch
            chartSettings = tempVuData?.ChartSettings
            tableSettings = tempVuData?.TableSettings
            tempvuIdAlreadyInExploreMode = tempVuData?.TempVisualUnitId
            if (!tempvuIdAlreadyInExploreMode) tempvuIdAlreadyInExploreMode = -1 // brand new explore session
        } else {
            viewerType = tempVuData.ViewerType
            chartSwitch = tempVuData.ChartSwitch
            chartSettings = tempVuData.ChartSettings
        }
        if (!viewerType) {
            viewerType = FoundationsEnums.VisualUnitViewerType.Table
        }
        let indexedVuOj: VisualUnitApiDTO_EditSaveVisualUnit = { ...JSON.parse(vuObj)[vuIndex] }
        let filteredDimensionRows = indexedVuOj?.dimensionRow?.filter((x, index) => {
            x.id !== -1
        })
        let filteredDimensionCols = indexedVuOj?.dimensionCol?.filter((y, index) => {
            y.id !== -1
        })
        if (filteredDimensionRows?.length === 0 && filteredDimensionCols?.length === 0) {
            viewerType = FoundationsEnums.VisualUnitViewerType.SVU
        }

        let clientPreViewDtoRequest = {
            ...indexedVuOj,
            VisualUnitId: vuId,
            TempVisualUnitId: tempVuData?.TempVisualUnitId,
            viewerType: tempVuData.ViewerType,
            chartSwitch: chartSwitch,
            chartSettings: chartSettings,
            refineMode: false,
            BuildQuery: true,
            tableSettings: tableSettings, //must include table settings- FP-11395
            exploreTempVUId: tempvuIdAlreadyInExploreMode,
        }
        redrawVisualUnitParams(clientPreViewDtoRequest, null, tempVuData.ViewerType) //we are correctly passing props
    }

    const Close = () => {
        setTimeout(() => {
            setOpenVUParamsDialog(false)
        }, 100)
    }

    const cancelVisualUnitParams = (vuId: number, vuIndex: number, isRefine = false) => {
        setVuDataObj((prev: any) => ({ ...prev, explore: 'no', vuTempId: -1 }))
        setIsExplore(false)
        if (isRefine) {
        }
    }

    const showDialogTitle = () => {
        let title: string = ''
        return (title =
            addAction === 'addmeasure' || addAction === 'updateMeasure'
                ? 'Select Measure'
                : addAction === 'addfilter' || addAction === 'updateFilter'
                    ? 'Select Filter'
                    : addAction === 'addrow' || addAction === 'updateRow'
                        ? 'Select Dimension (row)'
                        : 'Select Dimension (column)')
    }
    return (
        <>
            <div
                id={`dashboard_vu_params_${vuId}`}
                style={{ display: 'block' }}
            >
                {isParamsLoading ? (
                    <div className="padding-small">
                        <div className="ajax-loading-box">
                            <span className="ajax-loading-image"></span>Loading...
                        </div>
                    </div>
                ) : (
                    <React.Fragment>
                        <table id={`vu_params_table_${vuId}`} className="dashboard-vu-params-table">
                            <tbody>
                                <tr>
                                    <td className="td-measures">
                                        <div className="measures">
                                            <div className="header float-left">Measures</div>
                                            <div className="action float-right">
                                                <a
                                                    href="javascript:void(0);"
                                                    onClick={() => {
                                                        addNewMeasure(
                                                            vuId,
                                                            getVisualUnitParamsIndex(
                                                                vuId,
                                                                vuObjDataInfoFromStore
                                                            ),
                                                            false,
                                                            true
                                                        )
                                                    }}
                                                    title="Add a new measure"
                                                >
                                                    Add
                                                </a>
                                            </div>
                                            <div className="clear-both"></div>
                                            <MeasureFrame
                                                showUpdateMeasureDialog={addNewMeasure}
                                                vuObj={vuObj}
                                                setAvailMeasures={setAvailMeasures}
                                                availMeasures={availMeasures}
                                                vuId={vuId}
                                                setVuObj={setVuObj}
                                                displayFieldErrors={displayFieldErrors}
                                                setShowSaveandSaveAs={setShowSaveandSaveAs}
                                            />
                                        </div>
                                    </td>
                                    <td className="td-filterables">
                                        <div className="filterables">
                                            <div className="header float-left">Filters</div>
                                            <div className="action float-right">
                                                <a
                                                    href="javascript:void(0);"
                                                    onClick={() => {
                                                        addNewFilterable(
                                                            vuId,
                                                            getVisualUnitParamsIndex(
                                                                vuId,
                                                                vuObjDataInfoFromStore
                                                            ),
                                                            false,
                                                            true
                                                        )
                                                    }}
                                                    title="Add a new filter"
                                                >
                                                    Add
                                                </a>
                                            </div>
                                            <div className="clear-both"></div>
                                            <FilterFrame
                                                showUpdateFilterDialog={addNewFilterable}
                                                objDataFromStore={vuObj}
                                                availFilters={availFilters}
                                                vuId={vuId}
                                                setAvailFilters={setAvailFilters}
                                                setVuObj={setVuObj}
                                                setShowSaveandSaveAs={setShowSaveandSaveAs}
                                            />
                                        </div>
                                    </td>
                                    <DimensionFrame
                                        // Warroom- 29 April, Created new component, merging DimensionRowFrame, colFrame into one component to achieve drag and drop between cross components..
                                        availRows={availRows}
                                        availCols={availCols}
                                        setAvailRows={setAvailRows}
                                        setAvailCols={setAvailCols}
                                        vuId={vuId}
                                        showDimensionListDialog={showDimensionListDialog}
                                        objDataFromStore={vuObj}
                                        getVisualUnitParamsIndex={getVisualUnitParamsIndex}
                                        setVuObj={setVuObj}
                                        displayFieldErrors={displayFieldErrors}
                                        setShowSaveandSaveAs={setShowSaveandSaveAs}
                                    />
                                </tr>
                            </tbody>
                        </table>
                            <div
                            id={'vu_params_error_' + vuId}
                            className={`padding-small ${highlightClass?.vu_params_error ?? ""}`}
                            >
                                {fieldErrors.length > 0 && fieldErrors.map((field_error, errIndex) => (
                                    <React.Fragment key={`field_error_${errIndex}`}>
                                        <span style={{ color: 'red', fontSize: '12px' }}>{field_error}</span>
                                        <br />
                                    </React.Fragment>
                                ))}
                            </div>

                            <div className="dashboard-vu-params-buttons">
                                {showSaveandSaveAs && (
                                <div className="float-left">
                                    <button
                                    type="button"
                                    id={'button_vu_params_save_' + vuId}
                                    className= {`ui-button app-button save_vu_param ${!isSaveAllowed ? 'disabled' : ''}`}
                                    color="#DCDCDC"
                                    onClick={() => onEditSave()}
                                    disabled = {!isSaveAllowed ? true : false} 
                                    title = {!isSaveAllowed ? 'You do not have the security privilege to save reports.' : ''}
                                >
                                    <span className="ui-button-text">Save</span>
                                </button>
                                <button
                                    onClick={() => handleSaveAsParams()}
                                    type="button"
                                    id={`button_vu_params_saveas_${vuId}`}
                                    className={`ui-button app-button saveas_vu_param ${operationMode === 'addNewVU' ? 'disabled' : ''}`}
                                    title={
                                        operationMode === 'addNewVU'
                                            ? 'Saving as functionality is not available while creating a new report.'
                                            : ''
                                    }
                                    disabled={operationMode === 'addNewVU'} //added to prevent clicks.
                                >
                                    <span className="ui-button-text">Save as</span>
                                </button>
                            </div>)}

                            <div className="float-right">
                                {isParamsRefreshing && (
                                    <div
                                        id={`vu_loading_exp_${vuId}`}
                                        className="padding-top-small padding-right-large float-left"
                                    >
                                        <span className="ajax-loading-box">
                                            <span className="ajax-loading-image">Loading...</span>
                                        </span>
                                    </div>
                                )}
                                <button
                                    type="button"
                                    id={`vu_params_button_buildQuery_${vuId}`}
                                    className="ui-button app-button"
                                    style={{ width: '100px' }}
                                    onClick={BuildQuery}
                                    title="Generate Report Query"
                                >
                                    <span className="ui-button-text">Build Query</span>
                                </button>
                                <button
                                    onClick={() => refreshParamsClicked()}
                                    type="button"
                                    id={`vu_params_button_redraw_${vuId}`}
                                    className="ui-button app-button refresh_vu_param"
                                    style={{ width: '80px' }}
                                >
                                    <span className="ui-button-text">Refresh</span>
                                </button>
                                <button
                                    type="button"
                                    id={`vu_params_button_cancel_${vuId}`}
                                    className="ui-button app-button negative cancel_vu_param "
                                    onClick={() => {
                                        if (operationMode === 'addNewVU' || operationMode === 'copyVU') {
                                            setDeleteNewlyAddedVU(true)
                                        } else {
                                            cancelVisualUnitParams(
                                                vuId,
                                                getVisualUnitParamsIndex(
                                                    vuId,
                                                    vuObjDataInfoFromStore
                                                ),
                                                true
                                            )
                                        }
                                    }}
                                >
                                    <span className="ui-button-text">Cancel</span>
                                </button>
                            </div>
                            <div className="clear-both"></div>
                            <Dialog
                                isOpen={deleteNewlyAddedVU}
                                onClose={() => setDeleteNewlyAddedVU(!deleteNewlyAddedVU)}
                                className="ui-front ui-dialog-buttons left-align-text"
                                title="Delete Report Permanently"
                                width={'370px'}
                                buttons={[
                                    {
                                        label: 'Cancel',
                                        id: 'cancelDeleteVU',
                                        onClick: () => setDeleteNewlyAddedVU(!deleteNewlyAddedVU),
                                        className:
                                            'ui-button ui-corner-all ui-widget app-button negative',
                                    },
                                    {
                                        label: 'Delete',
                                        id: 'confirmDeleteVU',
                                        onClick: deleteClicked,
                                        className: 'ui-button ui-corner-all ui-widget app-button',
                                    },
                                ]}
                            >
                                Please confirm you want to delete this report{' '}
                                <strong>permanently</strong>?
                                <br />
                                <br />
                                This report will be deleted from <strong>all</strong> workspaces.
                                <br />
                                <br />
                                <strong> This operation cannot be undone.</strong>
                            </Dialog>
                            {/* {openVUParamsDialog &&  FP-11949 no need this extra check, Making opening stable ( */}
                            <Dialog
                                isOpen={openVUParamsDialog}
                                onClose={() => Close()} // Close dialog on overlay or close button click
                                className="ui-front ui-dialog-buttons"
                                title={showDialogTitle()}
                                width={'960px'} // Fixed as per previous version
                            >
                                <VisualUnitParamsDialog
                                    availMeasures={
                                        addAction === 'addmeasure' ||
                                            addAction === 'updateMeasure'
                                            ? availMeasures
                                            : addAction === 'addrow' ||
                                                addAction === 'updateRow'
                                                ? availRows
                                                : addAction === 'addcolumn' ||
                                                    addAction === 'updateColumn'
                                                    ? availCols
                                                    : addAction === 'addfilter' ||
                                                        addAction === 'updateFilter'
                                                        ? availFilters
                                                        : []
                                    }
                                    vuObjFromStore={vuObj}
                                    updateIndex={updateIndexRef.current}
                                    selectedParameters={{ data: updatePayload }}
                                    addMeasureFn={addMeasureFromDialog}
                                    vuId={vuId}
                                    paramsAction={addAction}
                                    categoriesData={categories}
                                    groupCategoriesData={groupedMeasures}
                                    onClose={Close}
                                    getHLMetadata={getHLMetadata}
                                    setFieldErrors={setFieldErrors}
                                />
                            </Dialog>
                            {/* )} */}
                            {isSaveAsDialogOpen && (
                                <Dialog
                                    isOpen={isSaveAsDialogOpen}
                                    onClose={() => setisSaveAsDialogOpen(false)} // Close dialog
                                    className="ui-front ui-dialog-buttons"
                                    title="Save as a new Report"
                                    width={'480px'}
                                    buttons={[
                                        {
                                            label: 'Cancel',
                                            id: 'btnCancel',
                                            onClick: () => setisSaveAsDialogOpen(false),
                                            className: 'app-button negative',
                                        },
                                        {
                                            label: 'Save New Report',
                                            id: 'btnSaveNewReport',
                                            onClick: () => handleSaveAsNewReport(vuId),
                                            className: 'app-button',
                                        },
                                    ]}
                                >
                                    <div
                                        id="vu_details_dialog_wrapper"
                                        style={{
                                            display: 'block',
                                            width: 'auto',
                                            minHeight: '43.6px',
                                            height: 'auto',
                                        }}
                                    >
                                        <table className="input-form-table-popup-window vu-details-content">
                                            <tbody>
                                                <tr>
                                                    <td className="left" style={{ width: '25%' }}>
                                                        Name:
                                                    </td>
                                                    <td className="right">
                                                        <input
                                                            name="name"
                                                            className="field-name"
                                                            type="text"
                                                            size={40}
                                                            maxLength={100}
                                                            value={editSettingsformData.name}
                                                            onChange={(e) =>
                                                                handleChange('name', e.target.value)
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="left">
                                                        <div>Description:</div>
                                                        <div className="field-optional">
                                                            (optional)
                                                        </div>
                                                    </td>
                                                    <td className="right">
                                                        <textarea
                                                            name="description"
                                                            className="field-desc"
                                                            rows={6}
                                                            cols={40}
                                                            maxLength={255}
                                                            placeholder="Please add a description here for other users (Maximum 255 Characters)"
                                                            value={editSettingsformData.description}
                                                            onChange={(e) =>
                                                                handleChange(
                                                                    'description',
                                                                    e.target.value
                                                                )
                                                            }
                                                        ></textarea>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="left">Auto Refresh:</td>
                                                    <td className="right">
                                                        <select
                                                            name="autoRefresh"
                                                            className="field-auto-refresh"
                                                            value={
                                                                tempVuData.RefreshInterval != 0
                                                                    ? tempVuData.RefreshInterval
                                                                    : editSettingsformData.autoRefresh
                                                            }
                                                            onChange={(e) =>
                                                                handleChange(
                                                                    'refreshInterval',
                                                                    e.target.value
                                                                )
                                                            }
                                                        >
                                                            <option value="0">- no -</option>
                                                            <option value="1">
                                                                every 1 minute
                                                            </option>
                                                            <option value="5">
                                                                every 5 minutes
                                                            </option>
                                                            <option value="10">
                                                                every 10 minutes
                                                            </option>
                                                            <option value="15">
                                                                every 15 minutes
                                                            </option>
                                                            <option value="30">
                                                                every 30 minutes
                                                            </option>
                                                            <option value="45">
                                                                every 45 minutes
                                                            </option>
                                                            <option value="60">
                                                                every 60 minutes
                                                            </option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr id="visual_unit_privacy_lock">
                                                    <td className="left">Access Level:</td>
                                                    <td className="right">
                                                        <select
                                                            name="accessLevel"
                                                            className="field-auto-refresh"
                                                            value={
                                                                tempVuData.PrivacyLock != ''
                                                                    ? tempVuData.PrivacyLock
                                                                    : editSettingsformData.accessLevel
                                                            }
                                                            onChange={(e) =>
                                                                handleChange(
                                                                    'privacyLock',
                                                                    e.target.value
                                                                )
                                                            }
                                                        >
                                                            <option value="0">
                                                                Open, changes allowed
                                                            </option>
                                                            <option value="2">
                                                                Locked, only for me and
                                                                administrators
                                                            </option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr id="visual_unit_allow_drillthru">
                                                    <td className="left">Allow Drill thru:</td>
                                                    <td className="right">
                                                        <select
                                                            name="allowDrillThru"
                                                            className="field-auto-refresh"
                                                            value={
                                                                tempVuData.AllowDrillThru != ''
                                                                    ? tempVuData.AllowDrillThru
                                                                    : editSettingsformData.allowDrillThru
                                                            }
                                                            onChange={(e) =>
                                                                handleChange(
                                                                    'allowDrillThru',
                                                                    e.target.value
                                                                )
                                                            }
                                                        >
                                                            <option value="Y">
                                                                Yes, Allow Drill Thru
                                                            </option>
                                                            <option value="N">
                                                                No, Disable Drill Thru
                                                            </option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr id="visual_unit_drillthru_page_size">
                                                    <td className="left">Drillthru Page Size:</td>
                                                    <td className="right">
                                                        <select
                                                            name="drillThruPageSize"
                                                            className="field-auto-refresh"
                                                            value={
                                                                tempVuData.DrillthruPageSize != 0
                                                                    ? tempVuData.DrillthruPageSize
                                                                    : editSettingsformData.drillThruPageSize
                                                            }
                                                            onChange={(e) =>
                                                                handleChange(
                                                                    'drillThruPageSize',
                                                                    e.target.value
                                                                )
                                                            }
                                                        >
                                                            <option value="10">10 Rows</option>
                                                            <option value="20">20 Rows</option>
                                                            <option value="30">30 Rows</option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr id="visual_unit_auto_next">
                                                    <td className="left">Auto Next:</td>
                                                    <td className="right">
                                                        <input
                                                            type="checkbox"
                                                            name="autoNext"
                                                            checked={
                                                                tempVuData.IsEnabledAutoNavigation
                                                                    ? tempVuData.IsEnabledAutoNavigation
                                                                    : editSettingsformData.autoNext
                                                            }
                                                            onChange={(e) =>
                                                                handleChange(
                                                                    'autoNext',
                                                                    e.target.checked
                                                                )
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="left"></td>
                                                    <td className="right"></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2}>
                                                        <span
                                                            style={{
                                                                whiteSpace: 'normal',
                                                                fontSize: 'x-small',
                                                                color: 'red',
                                                            }}
                                                            id="verify_default_drillthruset_as_warning"
                                                        >
                                                            - Please verify your drillthru/detailed
                                                            view and configurations after the report
                                                            is saved.
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Dialog>
                            )}
                        </div>
                    </React.Fragment>
                )}
            </div>
        </>
    )
}
export default DashboardVUParams
